import { mockPharmacyDB } from './mockDb';
import type { Dispense, DispenseFormData } from '../types';

export const dispenseService = {
  async getAll(): Promise<Dispense[]> {
    return mockPharmacyDB.getDispenses();
  },

  async getById(id: string): Promise<Dispense | null> {
    const dispense = mockPharmacyDB.getDispense(id);
    return dispense || null;
  },

  async create(data: DispenseFormData): Promise<Dispense> {
    const total = data.items.reduce((sum, item) => sum + (item.qty * item.unitPrice), 0);

    const dispenseData: Omit<Dispense, 'id' | 'dateTime'> = {
      ...data,
      total,
    };

    return mockPharmacyDB.createDispense(dispenseData);
  },

  async getRecent(limit: number = 10): Promise<Dispense[]> {
    const dispenses = await this.getAll();
    return dispenses
      .sort((a, b) => new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime())
      .slice(0, limit);
  },

  async getByPatient(patientId: string): Promise<Dispense[]> {
    const dispenses = await this.getAll();
    return dispenses.filter(d => d.patientId === patientId);
  },

  async getByDateRange(startDate: string, endDate: string): Promise<Dispense[]> {
    const dispenses = await this.getAll();
    return dispenses.filter(d => 
      d.dateTime >= startDate && d.dateTime <= endDate
    );
  },

  async getTodaysDispenses(): Promise<Dispense[]> {
    const today = new Date().toISOString().split('T')[0];
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowStr = tomorrow.toISOString().split('T')[0];
    
    return this.getByDateRange(today, tomorrowStr);
  }
};
